import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { images } from '../../assets'
import style from './profileView.module.css'
// eslint-disable-next-line import/imports-first
// eslint-disable-next-line import/no-duplicates
// eslint-disable-next-line import/imports-first,import/no-duplicates
import { database, storageRef } from '../../utils/firebase'
import BackComponent from "../../components/BackComponent/BackComponent";
import PopupModal from "../../components/ToggleModal/PopupModal";

function DoctorInformation(props) {
  const inputRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [licences, setLicenses] = useState([
    { country: '', state: '', licenseNo: '', billingNo: '' },
  ])

  const { me } = useSelector((state) => state.app)
  useEffect(() => {
    if (me?.signatureImageURL) {
      setUrl(me?.signatureImageURL)
    }
  }, [me.signatureImageURL])
  // eslint-disable-next-line camelcase
  const doctorId = me.id

  const pushUpdatestoFirebase = async (payload) => {
    try {
      const response = await database.ref().update(payload);
      return response?.data || response;
    } catch (e) {
      console.log(e)
    }
  }
  // eslint-disable-next-line no-shadow
  const handleInputChange = (e, index) => {
    const { name, value } = e.target
    const list = [...licences]
    list[index][name] = value
    setLicenses(list)
  }
  const handleAddAnotherLicense = () => {
    setLicenses([
      ...licences,
      { country: '', state: '', licenseNo: '', billingNo: '' },
    ])
  }

  const handleSubmitClick=()=>{
    // eslint-disable-next-line no-use-before-define
    formik.handleSubmit()
    // eslint-disable-next-line no-use-before-define
    toggleModal()
  }

  const handleRemove = (index) => {
    const list = [...licences]
    list.splice(index, 1)
    setLicenses(list)
  }
  const toggleModal = () => {
    setIsOpen((old) => !old)
  }

  const formik = useFormik({
    initialValues: {
      // title:  '',
      fullName: me?.doctorName || '',
      specialty: me?.jobTitle || '',
      email: me.email || '',
      image: { edit: false, data: me?.signatureImageURL || null },
      phone: me?.phoneNumber || '',
    },
    validationSchema: Yup.object({
      // title: Yup.string(),
      fullName: Yup.string().required('Name required'),
      specialty: Yup.string().required('Speciality required'),
      email: Yup.string().email('Invalid email').required('Email required'),
      image: Yup.object()
        .shape({
          edit: Yup.boolean(),
          data: Yup.mixed().required('Image required'),
        })
        .required('Image required'),
      phone: Yup.string(),
    }),

    onSubmit: async (values) => {
      try {
        setLoading(true)
        console.log('values', values)
        const { title, fullName, email, specialty, image, phone } = values
        let str = ''
        if (image.edit) {
          const ref = storageRef().ref(
            `signatureImages/${new Date().getTime()}`,
          )
          // eslint-disable-next-line no-await-in-loop
          const snapshot = await ref.put(image.data)
          // eslint-disable-next-line no-await-in-loop
          str = await snapshot.ref.getDownloadURL()
        } else {
          str = image.data
        }
        const updates = {}
        updates[`/doctors/${doctorId}/email`] = email
        if (phone) updates[`/doctors/${doctorId}/phoneNumber`] = phone
        // updates[`/doctors/${doctorId}/title`] = title
        updates[`/doctors/${doctorId}/signatureImageURL`] = str
        updates[`/doctors/${doctorId}/doctorName`] = fullName
        updates[`/doctors/${doctorId}/jobTitle`] = specialty
        await pushUpdatestoFirebase(updates)
        setLoading(false)
      } catch (e) {
        console.log('Error', e)
        alert('Profile update failed, please try again later')
        setLoading(false)
      }
    },
  })

  return (

    <div className={style.padding}>
      <BackComponent
        title={"Back"}
      />
      <div className={style.margin}>

        <div className={style.input}>
          <form className={style.input} onSubmit={formik.handleSubmit}>
            <span className={style.bold}>Personal information</span>
            <div className={style.input}>
              {/* <label>Title:</label>

          <select className={style.inputStyle}
            id="title"
            name="title"
            value={formik.values.title}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ display: "block" }}
          >
            <option >
              Select{" "}
            </option>
            <option value="" label="Select">
              {" "}
              Select.
            </option>
            <option value="dr" label="Dr">
              {" "}
               Dr.
            </option>
            <option value="admin" label="Admin">
              Admin
            </option>
          </select>
          {formik.touched.title && formik.errors.title ? (
            <div className={style.error}>{formik.errors.title}</div>
          ) : null} */}

              {/* <input className={style.inputStyle} */}
              {/*       id="title" */}
              {/*       name="title" */}
              {/*       type="text" */}
              {/*       onChange={formik.handleChange} */}
              {/*       onBlur={formik.handleBlur} */}
              {/*       value={formik.values.title } */}
              {/* /> */}
              {/* {formik.touched.title && formik.errors.title ? ( */}
              {/*  <div className={style.error}>{formik.errors.title}</div> */}
              {/* ) : null} */}

              <div>
              <label>Full name:</label>
              <input
                className={style.inputStyle}
                id="fullName"
                name="fullName"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.fullName}
              />
              {formik.touched.fullName && formik.errors.fullName ? (
                <div className={style.error}>{formik.errors.fullName}</div>
              ) : null}
              </div>

              <div>
              <label>Specialty:</label>
              <input
                className={style.inputStyle}
                id="specialty"
                name="specialty"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.specialty}
              />
              {formik.touched.specialty && formik.errors.specialty ? (
                <div className={style.error}>{formik.errors.specialty}</div>
              ) : null}

              </div>
              <div>
              <label>Email:</label>
              <input
                className={style.inputStyle}
                id="email"
                name="email"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className={style.error}>{formik.errors.email}</div>
              ) : null}

              </div>
              <div>
              <label>Phone Number:</label>
              <input
                className={style.inputStyle}
                id="phone"
                name="phone"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
              />
              {formik.touched.phone && formik.errors.phone ? (
                <div className={style.error}>{formik.errors.phone}</div>
              ) : null}
              </div>

              <div className={style.row}>
                <div className="col-md-4">
                  <span>Signature:</span>
                </div>

                <div className="col-md-8">
                  <div className={style.sigWidth}>
                    <div
                      className={
                        formik.values.image?.data
                          ? style.signFilled
                          : style.sign
                      }
                      onClick={() => inputRef.current.click()}
                    >
                      {formik.values.image?.data ? (
                        <div className={style.signDivFilled}>
                          <img
                            className={style.signImg}
                            src={
                              formik.values.image?.edit
                                ? URL.createObjectURL(formik.values.image?.data)
                                : formik.values.image?.data
                            }
                            alt="sign"
                          />
                        </div>
                      ) : (
                        <div className={style.signDiv}>
                          <img src={images.sign} alt="logo" />
                          sign
                        </div>
                      )}
                    </div>
                    <input
                      id="image"
                      name="image"
                      ref={inputRef}
                      type="file"
                      style={{ display: 'none' }}
                      accept="image/*"
                      onChange={(event) => {
                        formik.setFieldValue('image', {
                          edit: true,
                          data: event.currentTarget.files[0],
                        })
                      }}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.image &&
                    (formik.errors.image || formik.errors.image?.data) ? (
                      <div className={style.error}>
                        {formik.errors.image || formik.errors.image?.data}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/*
          <div className={style.divSpace} />
*/}

              {
                // eslint-disable-next-line array-callback-return
                /* licences.map( (x,i)=> {
              return(
              <div key={i}>

                <div className={style.remove}>
                  <span className={style.bold}>License requirements:</span>
                  { licences.length!==1 &&
                    <button className={style.removeButton}  onClick={ ()=> handleRemove(i)}>
                      <img src={images.cross} className={style.crossIcon} alt="logo"/></button>
                  }
                </div>
                <label>Country:</label>
                <input className={style.inputStyle} required="country required" name="country" type="text" onChange={e => handleInputChange(e, i)}
                />
                <label>Province or state:</label>
                <input className={style.inputStyle} required="state required" name="state" type="text" onChange={e => handleInputChange(e, i)}
                />

                <label>License number:</label>
                <input className={style.inputStyle} required="licenseNo required" name="licenseNo" type="text" onChange={e => handleInputChange(e, i)}
                />

                <label>Billing number:</label>
                <input className={style.inputStyle} required="billingNo required" name="billingNo" type="text" onChange={e => handleInputChange(e, i)}
                />

              </div>

              );
            })} */
              }
              <div className={style.buttonDiv}>
                {/*
            <button className={style.licenseButton}  onClick={handleAddAnotherLicense}>Add another license</button>
*/}

                <button className={style.Savebutton} type="button" onClick={toggleModal}>Save</button>
                {isOpen && <PopupModal
                  isDocInformation={true}
                  handleClick={handleSubmitClick}
                  content={"Are you sure you want to save this information?"}
                  toggleModal={toggleModal}
                />}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default DoctorInformation
